import request from 'services/request';

export async function businessStructureMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/BusinessStructure/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
